import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";


import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Select from "../../../../../../components/select/Select";

class SezioneOtto extends Component {

    state = {
        sezioneOtto: {
            contagioConoscente: "",
            inizioMalattiaConoscente: "",
            conviventeHbsAg: "",
            tipoRelazione: "",
            portatoreHbsAg: "",
            motivoNonVaccinazione: "",
            altroVaccinazione: "",
            conviventeantiHCV: "",
            conviventeTossicodipendente: "",
            partnerPre: "",
            partnerFemminili: "",
            partnerMaschili: "",
            partnerRecenti: "",
            rapportiOccasionali: "",
            profilattico: "",
            numPersone: "",
            bambini: "",
            donatore: "",
            corretto: []
        },
        controlloAutocomplete:{
            tipoRelazione:true
        }

    }


    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.validate = this.validate.bind(this)
        this.createJsonBackend = this.createJsonBackend.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneOtto) {
            let sezioneOtto = this.state.sezioneOtto
            let controlloAutocomplete=this.state.controlloAutocomplete
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneOtto))
            sezioneOtto.contagioConoscente = propsSezione.contagioConoscente ? propsSezione.contagioConoscente : ""
            sezioneOtto.inizioMalattiaConoscente = propsSezione.inizioMalattiaConoscente ? propsSezione.inizioMalattiaConoscente : ""
            sezioneOtto.conviventeHbsAg = propsSezione.conviventeHbsAg ? propsSezione.conviventeHbsAg : ""
            sezioneOtto.tipoRelazione = propsSezione.tipoRelazione ? propsSezione.tipoRelazione : ""
            controlloAutocomplete.tipoRelazione=propsSezione.tipoRelazione && Utils.arrayToMap(OggettiUtili.relazioneSEIEVA, "codice")[sezioneOtto.tipoRelazione] ? true : false
            sezioneOtto.portatoreHbsAg = propsSezione.portatoreHbsAg ? propsSezione.portatoreHbsAg : ""
            sezioneOtto.motivoNonVaccinazione = propsSezione.motivoNonVaccinazione ? propsSezione.motivoNonVaccinazione : ""
            sezioneOtto.altroVaccinazione = propsSezione.altroVaccinazione ? propsSezione.altroVaccinazione : ""
            sezioneOtto.conviventeantiHCV = propsSezione.conviventeantiHCV ? propsSezione.conviventeantiHCV : ""
            sezioneOtto.conviventeTossicodipendente = propsSezione.conviventeTossicodipendente ? propsSezione.conviventeTossicodipendente : ""
            sezioneOtto.partnerPre = propsSezione.partnerPre ? propsSezione.partnerPre : ""
            sezioneOtto.partnerFemminili = propsSezione.partnerFemminili ? propsSezione.partnerFemminili : ""
            sezioneOtto.partnerMaschili = propsSezione.partnerMaschili ? propsSezione.partnerMaschili : ""
            sezioneOtto.partnerRecenti = propsSezione.partnerRecenti ? propsSezione.partnerRecenti : ""
            sezioneOtto.rapportiOccasionali = propsSezione.rapportiOccasionali ? propsSezione.rapportiOccasionali : ""
            sezioneOtto.profilattico = propsSezione.profilattico ? propsSezione.profilattico : ""
            sezioneOtto.numPersone = propsSezione.numPersone ? propsSezione.numPersone : ""
            sezioneOtto.bambini = propsSezione.bambini ? propsSezione.bambini : ""
            sezioneOtto.donatore = propsSezione.donatore ? propsSezione.donatore : ""

            this.setState({sezioneOtto: sezioneOtto,controlloAutocomplete: controlloAutocomplete})
        }
        this.controllaDati()
        this.props.setSezioneOtto(this.state.sezioneOtto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneOtto(this.state.sezioneOtto, this.validate(), res)
        }
    }

    validate() {
        if (this.state.sezioneOtto.contagioConoscente !== "01" && this.state.sezioneOtto.inizioMalattiaConoscente) return "Messages.ERR_01_02_0D_AR"
        else if (this.state.sezioneOtto.conviventeHbsAg !== "01" && this.state.sezioneOtto.tipoRelazione) return "Messages.ERR_01_02_0D_AS"
        else if (this.state.sezioneOtto.conviventeHbsAg !== "01" && this.state.sezioneOtto.portatoreHbsAg) return "Messages.ERR_01_02_0D_AT"
        else if (this.state.sezioneOtto.portatoreHbsAg !== "01" && this.state.sezioneOtto.motivoNonVaccinazione) return "Messages.ERR_01_02_0D_AU"
        else if (this.state.sezioneOtto.partnerPre !== "01" && this.state.sezioneOtto.partnerFemminili) return "Messages.ERR_01_02_0D_AZ"
        else if (this.state.sezioneOtto.partnerPre !== "01" && this.state.sezioneOtto.partnerMaschili) return "Messages.ERR_01_02_0D_AV"
        else if (this.state.sezioneOtto.rapportiOccasionali !== "01" && this.state.sezioneOtto.profilattico) return "Messages.ERR_01_02_0D_BA"

        return ""
    }


    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneOtto))
        let sezioneBackend = Utils.removeEmptyValueFromObject(dati)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneOtto
        dati.corretto = []

        if(dati.contagioConoscente === "01" && dati.inizioMalattiaConoscente === "") dati.corretto[0] = "Campo \"La loro malattia è iniziata meno di due mesi prima della sua?\" mancante";
        if(dati.conviventeHbsAg === "01" && dati.tipoRelazione === "" ) dati.corretto[1] = "Campo \"Tipo di relazione\" mancante";
        if(dati.conviventeHbsAg === "01" && dati.portatoreHbsAg === "") dati.corretto[2] = "Campo \"Era a conoscenza che un componente della sua famiglia (o il suo partner) era portatore di HBsAg prima che Lei avesse l'epatite acuta?\" mancante";
        if(dati.portatoreHbsAg === "01" && dati.motivoNonVaccinazione === "") dati.corretto[3] = "Campo \"Perché non si era vaccinato?\" mancante";
        if(dati.partnerPre === "01" && dati.partnerFemminili === "" ) dati.corretto[4] = "Campo \"Se si, con quanti partner ha avuto rapporti sessuali? - N. partner femminili\" mancante";
        if(dati.partnerPre === "01" && dati.partnerMaschili === "") dati.corretto[5] = "Campo \"Se si, con quanti partner ha avuto rapporti sessuali? - N. partner maschili\" mancante";
        if(dati.rapportiOccasionali === "01" && dati.profilattico === "") dati.corretto[6] = "Campo \"Ha usato il profilattico?\" mancante";
        if(dati.motivoNonVaccinazione === "04" && dati.altroVaccinazione === "") dati.corretto[7] = "Campo \"Perché non si era vaccinato? - Altro\" mancante";

    }

    riceviValoreRadioButton(event, field) {
        let sezioneOtto = this.state.sezioneOtto
        sezioneOtto[field] = event

        if (sezioneOtto.portatoreHbsAg !== "01" || sezioneOtto.conviventeHbsAg !== "01") {
            sezioneOtto.motivoNonVaccinazione = ""
            sezioneOtto.altroVaccinazione = ""
        }

        if (sezioneOtto.contagioConoscente !== "01") {
            sezioneOtto.inizioMalattiaConoscente = ""

        }

        if (sezioneOtto.conviventeHbsAg !== "01") {
            sezioneOtto.portatoreHbsAg = ""
        }

        if (sezioneOtto.rapportiOccasionali !== "01") {
            sezioneOtto.profilattico = ""
        }


        this.setState({sezioneOtto: sezioneOtto})
    }

    riceviValoreInput(field, event) {

        let sezioneOtto = this.state.sezioneOtto
        let controlloAutocomplete=this.state.controlloAutocomplete
        if (field.currentTarget) {
            sezioneOtto[field.currentTarget.id] = field.currentTarget.value

        } else {
            if (field.includes("tipoRelazione") && !event.target.value) {
                controlloAutocomplete.tipoRelazione = true
            }
            sezioneOtto[field] = event.target.value

        }

        this.setState({sezioneOtto: sezioneOtto,controlloAutocomplete: controlloAutocomplete})
    }

    render() {

        const {t} = this.props;

        const sezioneOtto = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 8</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.sezione8.domandaUno")}</b>
                        </p></div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"contagioConoscenteSi"}
                                             name={"contagioConoscente"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "contagioConoscente")}
                                             checked={this.state.sezioneOtto.contagioConoscente === "01"}>
                                </RadioButton>
                                <RadioButton id={"contagioConoscenteNo"}
    name={"contagioConoscente"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "contagioConoscente")}
    checked={this.state.sezioneOtto.contagioConoscente === "02"}
    />
                                <RadioButton id={"contagioConoscenteNonSo"}
    name={"contagioConoscente"}
    label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "contagioConoscente")}
    checked={this.state.sezioneOtto.contagioConoscente === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaDue")}</b>
                                {(this.state.sezioneOtto.contagioConoscente === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"inizioMalattiaConoscenteSi"}
                                             name={"inizioMalattiaConoscente"}
                                             label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             disabled={this.state.sezioneOtto.contagioConoscente !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "inizioMalattiaConoscente")}
                                             checked={this.state.sezioneOtto.inizioMalattiaConoscente === "01"}>
                                </RadioButton>
                                <RadioButton id={"inizioMalattiaConoscenteNo"}
    name={"inizioMalattiaConoscente"}
    label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    disabled={this.state.sezioneOtto.contagioConoscente !== "01"}
    onClick={() => this.riceviValoreRadioButton("02", "inizioMalattiaConoscente")}
    checked={this.state.sezioneOtto.inizioMalattiaConoscente === "02"}
    />
                                <RadioButton id={"inizioMalattiaConoscenteNonSo"}
    name={"inizioMalattiaConoscente"}
    label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    disabled={this.state.sezioneOtto.contagioConoscente !== "01"}
    onClick={() => this.riceviValoreRadioButton("03", "inizioMalattiaConoscente")}
    checked={this.state.sezioneOtto.inizioMalattiaConoscente === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaTre")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"conviventeHbsAgSi"}
                                             name={"conviventeHbsAg"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "conviventeHbsAg")}
                                             checked={this.state.sezioneOtto.conviventeHbsAg === "01"}>
                                </RadioButton>
                                <RadioButton id={"conviventeHbsAgeNo"}
    name={"conviventeHbsAg"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "conviventeHbsAg")}
    checked={this.state.sezioneOtto.conviventeHbsAg === "02"}
    />
                                <RadioButton id={"conviventeHbsAgNonSo"}
    name={"conviventeHbsAg"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "conviventeHbsAg")}
    checked={this.state.sezioneOtto.conviventeHbsAg === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaQuattro")}</b>
                                {(this.state.sezioneOtto.conviventeHbsAg === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            {(this.state.sezioneOtto.tipoRelazione && Utils.arrayToMap(OggettiUtili.relazioneSEIEVA, "codice")[this.state.sezioneOtto.tipoRelazione]) || !this.state.sezioneOtto.tipoRelazione || this.state.controlloAutocomplete.tipoRelazione ?

                                <Select
                                    id={"tipoRelazione"}
                                    field={"tipoRelazione"}
                                    newSelect={true}
                                    value={this.state.sezioneOtto.tipoRelazione}
                                    onChange={this.riceviValoreInput}
                                    functionMap={Utils.sortByKey(OggettiUtili.relazioneSEIEVA, "descrizione").map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}/>
                                :
                                <Input
                                    id="tipoRelazione"
                                    onChange={this.riceviValoreInput}
                                    field={"tipoRelazione"}
                                    value={this.state.sezioneOtto.tipoRelazione}
                                    placeholder={"Tipo"}
                                >
                                </Input>
                            }

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaCinque")}</b>
                                {(this.state.sezioneOtto.conviventeHbsAg === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"portatoreHbsAgSi"}
                                             name={"portatoreHbsAg"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             disabled={this.state.sezioneOtto.conviventeHbsAg !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "portatoreHbsAg")}
                                             checked={this.state.sezioneOtto.portatoreHbsAg === "01"}>
                                </RadioButton>
                                <RadioButton id={"portatoreHbsAgNo"}
    name={"portatoreHbsAg"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    disabled={this.state.sezioneOtto.conviventeHbsAg !== "01"}
    onClick={() => this.riceviValoreRadioButton("02", "portatoreHbsAg")}
    checked={this.state.sezioneOtto.portatoreHbsAg === "02"}
    />
                                <RadioButton id={"portatoreHbsAgNonSo"}
    name={"portatoreHbsAg"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    disabled={this.state.sezioneOtto.conviventeHbsAg !== "01"}
    onClick={() => this.riceviValoreRadioButton("03", "portatoreHbsAg")}
    checked={this.state.sezioneOtto.portatoreHbsAg === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaSei")}</b>
                                {(this.state.sezioneOtto.portatoreHbsAg === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">

                            <RadioButton id={"motivoNonVaccinazione1"}
                                         name={"motivoNonVaccinazione"} label={t("SchedaEpatite.sezione8.opzione1")}
                                         value={"01"}
                                         disabled={this.state.sezioneOtto.portatoreHbsAg !== "01"}
                                         onClick={() => this.riceviValoreRadioButton("01", "motivoNonVaccinazione")}
                                         checked={this.state.sezioneOtto.motivoNonVaccinazione === "01"}>
                            </RadioButton>
                            <RadioButton id={"motivoNonVaccinazione2"}
                                         name={"motivoNonVaccinazione"} label={t("SchedaEpatite.sezione8.opzione2")}
                                         value={"02"}
                                         disabled={this.state.sezioneOtto.portatoreHbsAg !== "01"}
                                         onClick={() => this.riceviValoreRadioButton("02", "motivoNonVaccinazione")}
                                         checked={this.state.sezioneOtto.motivoNonVaccinazione === "02"}
                            />
                            <RadioButton id={"motivoNonVaccinazione3"}
                                         name={"motivoNonVaccinazione"} label={t("SchedaEpatite.sezione8.opzione3")}
                                         value={"03"}
                                         disabled={this.state.sezioneOtto.portatoreHbsAg !== "01"}
                                         onClick={() => this.riceviValoreRadioButton("03", "motivoNonVaccinazione")}
                                         checked={this.state.sezioneOtto.motivoNonVaccinazione === "03"}
                            />
                            <div className="row">
                                <div className="col-lg-4"><RadioButton id={"motivoNonVaccinazione4"}
                                                                       name={"motivoNonVaccinazione"}
                                                                       label={t("SchedaEpatite.sezione8.opzione4")}
                                                                       value={"04"}
                                                                       disabled={this.state.sezioneOtto.portatoreHbsAg !== "01"}
                                                                       onClick={() => this.riceviValoreRadioButton("04", "motivoNonVaccinazione")}
                                                                       checked={this.state.sezioneOtto.motivoNonVaccinazione === "04"}
                                />
                                </div>
                                <div className="col-lg-4">
                                    <Input
                                        id="altroVaccinazione"
                                        onChange={this.riceviValoreInput}
                                        field={"altroVaccinazione"}
                                        required={this.state.sezioneOtto.motivoNonVaccinazione === "04"}
                                        disabled={this.state.sezioneOtto.motivoNonVaccinazione !== "04"}
                                        value={this.state.sezioneOtto.altroVaccinazione}
                                        placeholder={"Motivo"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaSette")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"conviventeantiHCVSi"}
                                             name={"conviventeantiHCV"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "conviventeantiHCV")}
                                             checked={this.state.sezioneOtto.conviventeantiHCV === "01"}>
                                </RadioButton>
                                <RadioButton id={"conviventeantiHCVNo"}
    name={"conviventeantiHCV"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "conviventeantiHCV")}
    checked={this.state.sezioneOtto.conviventeantiHCV === "02"}
    />
                                <RadioButton id={"conviventeantiHCVNonSo"}
    name={"conviventeantiHCV"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "conviventeantiHCV")}
    checked={this.state.sezioneOtto.conviventeantiHCV === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaOtto")}</b>
                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"conviventeTossicodipendenteSi"}
                                             name={"conviventeTossicodipendente"}
                                             label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "conviventeTossicodipendente")}
                                             checked={this.state.sezioneOtto.conviventeTossicodipendente === "01"}>
                                </RadioButton>
                                <RadioButton id={"conviventeTossicodipendenteNo"}
    name={"conviventeTossicodipendente"}
    label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "conviventeTossicodipendente")}
    checked={this.state.sezioneOtto.conviventeTossicodipendente === "02"}
    />
                                <RadioButton id={"conviventeTossicodipendenteNonSo"}
    name={"conviventeTossicodipendente"}
    label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "conviventeTossicodipendente")}
    checked={this.state.sezioneOtto.conviventeTossicodipendente === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaNove")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"partnerPreSi"}
                                             name={"partnerPre"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "partnerPre")}
                                             checked={this.state.sezioneOtto.partnerPre === "01"}>
                                </RadioButton>


                                <RadioButton id={"partnerPreNo"}
    name={"partnerPre"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "partnerPre")}
    checked={this.state.sezioneOtto.partnerPre === "02"}
    />

                                <RadioButton id={"partnerPreNonSo"}
    name={"partnerPre"} label={t("SchedaEpatite.sezione8.nonRispondere")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "partnerPre")}
    checked={this.state.sezioneOtto.partnerPre === "03"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaDieci")}</b></p>
                        </div>
                        <div className="col-lg-6">

                            <div className="row">
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    {t("SchedaEpatite.sezione8.numPartnerFemminili")}
                                    {(this.state.sezioneOtto.partnerPre === "01") ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}

                                </p>
                                <div className="col-lg-2">
                                    <Input id="partnerFemminili"
                                           onChange={this.riceviValoreInput}
                                           field={"partnerFemminili"}
                                           value={this.state.sezioneOtto.partnerFemminili}
                                           type={"number"}
                                           min={"0"}
                                           placeholder={"Num"}>
                                    </Input>
                                </div>
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    {t("SchedaEpatite.sezione8.numPartnerMaschili")}
                                    {(this.state.sezioneOtto.partnerPre === "01") ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </p>
                                <div className="col-lg-2">
                                    <Input id="partnerMaschili"
                                           onChange={this.riceviValoreInput}
                                           field={"partnerMaschili"}
                                           value={this.state.sezioneOtto.partnerMaschili}
                                           type={"number"}
                                           min={"0"}
                                           placeholder={"Num"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaUndici")}</b></p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"partnerRecentiSi"}
                                             name={"partnerRecenti"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "partnerRecenti")}
                                             checked={this.state.sezioneOtto.partnerRecenti === "01"}>
                                </RadioButton>


                                <RadioButton id={"partnerRecentiNo"}
    name={"partnerRecenti"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "partnerRecenti")}
    checked={this.state.sezioneOtto.partnerRecenti === "02"}
    />

                                <RadioButton id={"partnerRecentiNonSo"}
    name={"partnerRecenti"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "partnerRecenti")}
    checked={this.state.sezioneOtto.partnerRecenti === "03"}
    />

                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaDodici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"rapportiOccasionaliSi"}
                                             name={"rapportiOccasionali"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "rapportiOccasionali")}
                                             checked={this.state.sezioneOtto.rapportiOccasionali === "01"}>
                                </RadioButton>


                                <RadioButton id={"rapportiOccasionaliNo"}
    name={"rapportiOccasionali"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "rapportiOccasionali")}
    checked={this.state.sezioneOtto.rapportiOccasionali === "02"}
    />

                                <RadioButton id={"rapportiOccasionaliNonSo"}
    name={"rapportiOccasionali"}
    label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "rapportiOccasionali")}
    checked={this.state.sezioneOtto.rapportiOccasionali === "03"}
    />

                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaTredici")}</b>
                                {(this.state.sezioneOtto.rapportiOccasionali === "01") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"profilattico1"}
                                             name={"profilattico"} label={t("SchedaEpatite.sezione8.sempre")}
                                             value={"01"}
                                             disabled={this.state.sezioneOtto.rapportiOccasionali !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "profilattico")}
                                             checked={this.state.sezioneOtto.profilattico === "01"}>
                                </RadioButton>
                                <RadioButton id={"profilattico2"}
                                             name={"profilattico"} label={t("SchedaEpatite.sezione8.occasionalmente")}
                                             value={"02"}
                                             disabled={this.state.sezioneOtto.rapportiOccasionali !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "profilattico")}
                                             checked={this.state.sezioneOtto.profilattico === "02"}
                                />

                                <RadioButton id={"profilattico3"}
                                             name={"profilattico"} label={t("SchedaEpatite.sezione8.mai")}
                                             value={"03"}
                                             disabled={this.state.sezioneOtto.rapportiOccasionali !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("03", "profilattico")}
                                             checked={this.state.sezioneOtto.profilattico === "03"}
                                />

                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaQuattordici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">

                            <div className="row">
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    {t("SchedaEpatite.sezione8.numPersone")}
                                </p>
                                <div className="col-lg-2">
                                    <Input id="numPersone"
                                           onChange={this.riceviValoreInput}
                                           field={"numPersone"}
                                           value={this.state.sezioneOtto.numPersone}
                                           type={"number"}
                                           min={"0"}
                                           placeholder={"Numero persone"}>

                                    </Input>
                                </div>

                            </div>

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaQuindici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"bambiniSi"}
                                             name={"bambini"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "bambini")}
                                             checked={this.state.sezioneOtto.bambini === "01"}>
                                </RadioButton>
                                <RadioButton id={"bambiniNo"}
    name={"bambini"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "bambini")}
    checked={this.state.sezioneOtto.bambini === "02"}
    />
                                <RadioButton id={"bambinieNonSo"}
    name={"bambini"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "bambini")}
    checked={this.state.sezioneOtto.bambini === "03"}
    />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione8.domandaSedici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"donatoreSi"}
                                             name={"donatore"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "donatore")}
                                             checked={this.state.sezioneOtto.donatore === "01"}>
                                </RadioButton>
                                <RadioButton id={"donatoreNo"}
    name={"donatore"} label={t("SchedaEpatite.risposteTipoUno.no")}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "donatore")}
    checked={this.state.sezioneOtto.donatore === "02"}
    />
                                <RadioButton id={"donatoreNonSo"}
    name={"donatore"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "donatore")}
    checked={this.state.sezioneOtto.donatore === "03"}
    />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneOtto}
        </div>
    }


}

export default withTranslation('common')(SezioneOtto)
